import script from "./ChatConversationHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatConversationHeader.vue?vue&type=script&setup=true&lang=js"

import "./ChatConversationHeader.vue?vue&type=style&index=0&id=8b4ce6be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b4ce6be"]])

export default __exports__